var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.properties_object, function(property, index) {
        return [
          index !== 0 ? _c("v-divider", { staticClass: "mx-4" }) : _vm._e(),
          _vm._v(" "),
          _c("summary-breakdown", {
            key: "property-" + index,
            staticClass: "py-3 px-4",
            attrs: {
              object: _vm.benefits,
              property: property,
              small: _vm.small
            }
          })
        ]
      }),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _vm._l(_vm.properties, function(property, index) {
        return [
          _c("summary-value", {
            key: index,
            staticClass: "py-3 px-4",
            attrs: {
              object: _vm.benefits,
              property: property,
              small: _vm.small,
              greyed: _vm.isGreyed(property),
              inverted: _vm.isInverted(property),
              "append-label": _vm.getLppLabel(_vm.client.lpp_type)
            }
          }),
          _vm._v(" "),
          _c("v-divider")
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }